import { httpsCallable } from 'firebase/functions';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { AsyncThunkCreator } from '../../../index';
import { SUBSCRIPTION_REDUCER_NAME } from '../types';
import { SubscriptionPlan, UserSubscriptionInterval } from '../../../../models/documents/Subscriptions';

type Payload = {
  plan: SubscriptionPlan;
  interval: UserSubscriptionInterval;
  promotionCode?: string;
};

export const createCheckoutSession = createAsyncThunk<{ url: string }, Payload, AsyncThunkCreator<number>>(
  `${SUBSCRIPTION_REDUCER_NAME}/createCheckoutSession`,
  async (payload, { rejectWithValue, extra: { functions } }) => {
    try {
      const res = await httpsCallable(functions, 'subscriptions-createCheckoutSession')(payload);
      return (res.data as any)?.body as { url: string };
    } catch (e) {
      const error = e as any;
      return rejectWithValue(error.message);
    }
  }
);
